// web_managerSupplier_unchecked 查询待审核供应商

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：http://192.168.0.15:8080/doc.html#/所有接口/manager-supplier-controller/getUncheckedSupplierUsingPOST

export default function web_managerSupplier_unchecked(pParameter) {
  if (!pParameter) pParameter = {};
  const currentPage = pParameter.currentPage || 1
  const pageSize = pParameter.pageSize || 10
  const userName = pParameter.userName || ''
  const companyName = pParameter.companyName || ''
  const cityId = pParameter.cityId || ''
  const regionId = pParameter.regionId || ''
  const provinceId = pParameter.provinceId || ''
  const applicationType = pParameter.applicationType || ''
  const supplierStatus = pParameter.supplierStatus || ''
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/managerSupplier/unchecked'
  params.data = {
    currentPage,
    pageSize,
    userName,
    companyName,
    cityId,
    regionId,
    provinceId,
    applicationType,
    supplierStatus
  }
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}
